import PropTypes from "prop-types";

export const goalPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
  description: PropTypes.string,
  slug: PropTypes.string.isRequired,
  isApproved: PropTypes.bool.isRequired,
});
